module.exports = __webpack_public_path__ + "img/infrastructure_monitoring.ad138d73.png";